import { isUndefined } from '@/util/validators/baseComponentsValidators'
import { storageService } from '~/services'
import { isPWA } from '~/util/isPwa'

const ERROR = {
  _401: {
    VALUE: 401,
    CODE: 401,
    MESSAGE: {
      TOKEN_EMPTY: 'token_empty',
      TOKEN_EXPIRED: 'token_expired',
      PASSWORD_CHANGED: 'password_changed',
      INVALID_TOKEN: 'invalid_token', // insurance
    },
  },
  _403: {
    VALUE: 403,
    CODE: 403,
    MESSAGE: {
      USER_DISABLED: 'user_disabled',
      USER_NOT_FOUND: 'user_not_found', // insurance
    },
  },
}

const setAdwHeaders = (headers) => {
  if (storageService.getUtm()) {
    headers['x-analytics-utm'] = storageService.getUtm()
  }
  if (storageService.getAdwCode()) {
    headers['x-analytics-affise'] = storageService.getAdwCode()
  }
  if (storageService.getStagCode()) headers['x-analytics-affilka'] = storageService.getStagCode()
}

const deleteAdwHeaders = (headers) => {
  delete headers['x-analytics-utm']
  delete headers['x-analytics-affise']
  delete headers['x-analytics-affilka']
}

function contractErrorLog(res) {
  console.error('BE provided invalid response config: ', res)
}

export default function({ $config, $axios, app: { store }, route, req }) {
  $axios.setBaseURL($config.apiUrl)
  // $axios.defaults.timeout = 3000
  $axios.onRequest(config => {
    config.withCredentials = true
    const token = store.getters['user/token']
      || storageService.getToken()
      || store.getters['base/isServerToken']

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      deleteAdwHeaders(config.headers)
    }
    else if (config?.headers) {
      delete $axios.defaults.headers.common['Authorization']
    }
    if (process.client) {
      setAdwHeaders(config.headers)
    }

    const url = route?.fullPath || req?.url || ''

    if (isPWA({ url })) {
      config.headers['X-Platform'] = 'pwa'
    }

    return config
  })

  $axios.onError(async (error) => {
    const { response } = error
    if (
      isUndefined(response)
      || isUndefined(response?.data)
    ) return contractErrorLog(error)
    const { data, status, config } = response
    const { errorCode, errorMessage } = data
    /** 401 */
    if (status === ERROR._401.VALUE) {
      /** 401 user */
      if (store.getters['user/isLoggedIn']) {
        if (errorMessage === ERROR._401.MESSAGE.PASSWORD_CHANGED) {
          await store.dispatch('globalModal/open_globalModalUserHasBeenLoggedOut')
        }
        store.commit('base/setServerToken', false)
        store.dispatch('user/logout')
      }
      /** 401 guest */
      else if (data.errors && !store.getters['user/isLoggedIn']) {
        if (
          config.url.includes('auth/social/cb/google')
          || config.url.includes('auth/social/cb/facebook')
          || config.url.includes('auth/social/cb/apple')
        ) {
          localStorage.setItem('userId', data.errors.user_id)
          throw response
        }
      }
    }
    /** 403 */
    else if (status === ERROR._403.VALUE) {
      /** 403 user disabled */
      if (errorMessage === ERROR._403.MESSAGE.USER_DISABLED) {
        store.dispatch('user/logout')
        store.dispatch('globalModal/open_globalModalAccountBlocked')
      }
    }
  })

  $axios.onResponse((res) => {
    if (!res) return
    const { status, data } = res
    const { errorCode, errorMessage } = data
    if (!data) return
    /**           !!! Soon will be removed !!!                */
    if (status === 200 && errorCode === 412) {
      if (errorMessage === ERROR._403.MESSAGE.USER_DISABLED) {
        store.dispatch('user/logout')
        store.dispatch('globalModal/open_globalModalAccountBlocked')
      }
      else if (errorMessage === ERROR._403.MESSAGE.USER_NOT_FOUND) {
        store.dispatch('user/logout')
      }
    }
  })
}
